import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import { motion, AnimatePresence } from 'motion/react';

function PageEngagementZone() {
    const { content: { engagement_zone: content } } = useAppStore();

    return (
    <Page className='flex space-between overflow-hidden pt-466u pr-220u relative'>
        <div className='absolute top-285u left-1/2 text-100u font-extralight -translate-x-1/2 z-30'>{content.title}</div>

        <div className='flex items-center w-full'>
            <AnimatePresence>
                <motion.div
                key="left_panel"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                className='flex flex-col
                w-1549u h-1489u
                pt-154u px-137u pb-131u
                border-2u border-[#D9D9D9] rounded-60u
                '>
                    <div className='text-72u font-extralight leading-80u mb-70u'>{content.subtitle}</div>
                    <div className='text-42u leading-68u font-light mb-auto [&_p]:mb-80u' dangerouslySetInnerHTML={{ __html: content.description || '' }}>
                    </div>
                    {/* Código QR */}
                    {/*
                    <div className='
                        w-full h-317u bg-[#091D39] rounded-30u
                        flex items-center justify-left
                        pl-62u
                        '>
                        <div className='w-189u h-189u mr-70u rounded-20u p-9u bg-[#D9D9D9] flex items-center justify-center'>
                            <img
                                src={`${process.env.PUBLIC_URL}/qr/engagement_zone_qr.png`}
                                className="w-full h-auto object-cover rounded-10u"
                            /> 
                        </div>
                        <div className='text-42u leading-none'>Scan to learn more</div>
                    </div>
                    */}
                </motion.div>

                <motion.div 
                key="connecting_line"
                className='w-full h-4u flex-1 border-t-4u border-dashed border-[#0A60FF]'
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.5 }}
                style={{ transformOrigin: 'left' }}
                />
                
                <motion.div
                key="right_panel"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
                className='
                w-669u h-1365u
                ml-auto
                rounded-50u border-2u border-[#E2E2E2] bg-[#0E2242]
                relative'>
                    <div className='w-462u h-full border-r-2u border-r-[#E2E2E2] flex items-center'>
                        <div className='w-6u h-669u bg-[#D9D9D9] ml-auto'></div>
                    </div>

                    {/* Semicírculo cortado verticalmente - solo parte derecha */}
                    <div className='absolute top-1/2 -translate-y-1/2 left-0 w-267u h-534u overflow-hidden'>
                        <div className='w-534u h-534u rounded-full bg-[#061933]/60 -translate-x-1/2'></div>
                    </div>
                    <div className='absolute top-99u left-138u w-165u h-165u rounded-full bg-[#061933]'></div>
                    <div className='absolute bottom-99u left-138u w-165u h-165u rounded-full bg-[#061933]'></div>
                    <div className='absolute left-156u top-1/2 -translate-y-1/2 w-51u h-121u rounded-10u bg-[#0A60FF]'></div>

                    {/* Círculo con animación de latido */}
                    <div className='absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2'>
                        {/* Círculo exterior con animación de latido */}
                        <motion.div 
                            className='
                            rounded-full
                            w-144u h-144u
                            bg-[#0A60FF]/50
                            '
                            animate={{ 
                                scale: [1, 1.2, 1],
                                opacity: [0.5, 0.8, 0.5]
                            }}
                            transition={{ 
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                        >
                        </motion.div>
                    </div>
                    {/* Círculo interior fijo */}
                    <div className='
                    rounded-full
                    w-89u h-89u
                    bg-[#0A60FF]
                    absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2
                    '></div>
                    
                </motion.div>
            </AnimatePresence>
        </div>
      
    </Page>
    );
}

export default PageEngagementZone;